<template>
    <v-layout wrap>
        <v-flex lg6 md12 pr-3>
            <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <v-text-field
                    :label="$t('selectImage') | capitalize"
                    @click="pickFile"
                    v-model='imageName'
                    prepend-inner-icon='attach_file'
                ></v-text-field>
                <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked"
                >
            </v-flex>
            <v-layout row wrap>
                <v-flex lg6>
                    <img :src="imageUrl" height="150" v-if="imageUrl"/>
                </v-flex>
                <v-flex lg6>
                    <table>
                        <tr v-for="field in fieldList" :key="field.name">
                            <td>{{field.label}}</td>
                            <td>{{model[field.name]}}</td>
                        </tr>
                    </table>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg6 md12 style="text-align: left">
            <h2 class="py-2">API</h2>
            <v-select
                label="API Key"
                v-model="apiKey"
                :items="listAPIKey"
                class="mt-3"
            ></v-select>
            <v-layout row reverse wrap align-center>
                <v-btn
                    @click="$utils.copyToClipboard(code[apiType], $t('copiedToClipboard', ['code']))"
                    title="copy key to clipboard"
                    class="ma-0"
                    depressed
                    color="info"
                >
                    <v-icon>file_copy</v-icon>
                    Copy
                </v-btn>
                <v-radio-group v-model="apiType" row>
                    <v-radio label="cUrl " value="curl"></v-radio>
                    <v-radio label="Python" value="python"></v-radio>
                    <v-radio label="Php" value="php"></v-radio>
                </v-radio-group>
            </v-layout>
            <code>{{code[apiType]}}</code>
        </v-flex>
    </v-layout>
</template>
<script>
import axios from 'axios'
import ApiDemo from '@/views/APIs/demo/ApiDemo'
/* eslint-disable */
import { inject } from '@/utils/VariableInjection'
import idrCUrl from 'raw-loader!../code/idrCUrl.txt'
import idrPython from 'raw-loader!../code/idrPython.txt'
import idrPHP from 'raw-loader!../code/idrPHP.txt'
/* eslint-enable */

export default {
    name: 'RecognitionDemo',
    extends: ApiDemo,
    props: {
        parent: Object
    },
    data () {
        return {
            model: {},
            imageName: '',
            imageUrl: '',
            imageFile: '',
            apiType: 'curl',
            listAPIKey: [],
            apiKey: '',
            demoUrl: '',
            fieldList: []
        }
    },
    computed: {
        code () {
            let variableMap = {
                url: this.demoUrl,
                apiKey: this.apiKey,
                path: this.imageName
            }
            return {
                python: inject(idrPython, variableMap),
                curl: inject(idrCUrl, variableMap),
                php: inject(idrPHP, variableMap)
            }
        }
    },
    methods: {
        pickFile () {
            this.$refs.image.click()
        },
        onFilePicked (e) {
            const files = e.target.files
            if (files[0] !== undefined) {
                this.imageName = files[0].name
                if (this.imageName.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener('load', () => {
                    let formData = new FormData()
                    formData.append('image', files[0])
                    this.$store.dispatch(this.$actionTypes.LOADING, true)
                    axios.post(
                        this.demoUrl,
                        formData,
                        {
                            headers: {
                                'api-key': this.apiKey,
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(
                        result => {
                            this.$store.dispatch(this.$actionTypes.LOADING, false)
                            let data = result.data
                            if (!data.errorCode || data.errorCode === 0) {
                                this.imageUrl = fr.result
                                this.imageFile = files[0]
                                if (Array.isArray(data.data)) {
                                    data = data.data[0]
                                } else {
                                    data = data.data
                                }
                                let newModel = {}
                                let fieldList = []
                                for (let i in data) {
                                    if (
                                        !i.includes('type') &&
                                        !i.includes('_prob') &&
                                        !i.includes('entities')
                                    ) {
                                        newModel[i] = data[i]
                                        fieldList.push({
                                            name: i,
                                            label: this.$filters.capitalize(this.$t('recognitionKeyGroup.' + i))
                                        })
                                    }
                                }
                                this.model = newModel
                                this.fieldList = fieldList
                                this.parent.getRemain()
                            } else {
                                this.$appService.toastError(data.errorMessage)
                            }
                        },
                        error => {
                            this.$store.dispatch(this.$actionTypes.LOADING, false)
                            if (error.response) {
                                if (error.response.status === 429) {
                                    this.$appService.toastError(this.$t('noRequestRemain'))
                                } else if (error.response.data) {
                                    this.$appService.toastError(error.response.data)
                                } else {
                                    this.$appService.toastError(this.$t('canNotExtractInformation'))
                                }
                            } else {
                                this.$appService.toastError(this.$t('canNotExtractInformation'))
                            }
                        }
                    )
                })
            } else {
                // this.imageName = ''
                // this.imageFile = ''
                // this.imageUrl = ''
            }
        }
    },
}
</script>
<style scoped>
    table tr td:first-child {
        font-weight: bold;
        padding: 5px 15px 5px 0;
    }

    table td {
        text-align: left;
    }

    code {
        padding: 5px;
        width: 100%;
    }

    code::before {
        content: "";
    }
</style>
